<template>
  <div class="join-us">
    <nav-header :activeIndex="5" />
    <header class="join-us-header">
      <div class="dialog"></div>
      <img src="../../assets/banner/pic-join-us.png" alt="">
      <div class="banner-inner">
        <p class="banner-inner-title">加入「圣诉」</p>
        <p class="banner-inner-content">迄今已有600多位律师加入圣诉平台</p>
        <p class="banner-inner-content">用专业的法律服务打造优质法律服务的新标准</p>
      </div>
    </header>
    <main class="join-us-main">
      <div class="join-us-main-inner">
        <div class="join-us-main-inner-item">
          <img src="./assets/pic.png" alt="">
          <router-link tag="div" :to="{name: 'join-us-detail', query: {type: 'user'}}" class="btn">我是客户</router-link>
          <div class="dialog"></div>
        </div>
        <div class="join-us-main-inner-item">
          <img src="./assets/pic-right.png" alt="">
          <router-link tag="div" :to="{name: 'join-us-detail', query: {type: 'lawyer'}}" class="btn">我是律师</router-link>
          <div class="dialog"></div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  import NavHeader from '@/common-components/nav-header'
  export default {
    name: 'join-us',
    components: { NavHeader }
  }
</script>

<style lang='stylus' scoped>
  @import '../../styles/constant.styl'
  .join-us {
    &-header {
      width: 100%
      height: 5rem
      img {
        width: 100%
        height: 100%
      }
      .dialog {
        width: 100%
        height: 5rem
        background #000
        position absolute
        top 0
        left 0
        opacity .5
      }
      .banner-inner {
        color: #fff
        position absolute
        top 2.20rem
        left 2.52rem
        &-title {
          font-size: .6rem;
          font-weight: 6rem;
        }
        &-content {
          margin .08rem 0 .08rem 0
          font-size: .36rem
          font-weight: 300
        }
      }
    }
    &-main {
      width: 100%
      background #f7f7f7
      &-inner {
        width: 9.6rem
        margin 0 auto
        padding .9rem 0
        display flex
        justify-content space-between
        &-item {
          width: 3.8rem
          height: 4.8rem
          position relative
          img {
            width: 100%
            height: 100%
          }
          .btn {
            position absolute
            top 50%
            left 50%
            transform translate(-50%, -50%)
            width: 2.84rem
            height: .64rem
            border: solid 2px #ffffff
            line-height:.64rem
            text-align center
            z-index 9
            font-size: .24rem;
            font-weight: 500;
            color #fff
            cursor pointer
          }
          .dialog {
            width: 100%
            height: 100%
            position absolute
            top 0
            left 0
            background #000
            opacity .5
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/join-us/join-us.vue